function sliderCollectionsThumbs() {
  const $slider = $('.slider-collections-thumbs');
  const slider = $slider.find('.swiper-container')[0];
  const sliderNext = $slider.find('.slider-next')[0];
  const sliderPrev = $slider.find('.slider-prev')[0];

  const mySlider = new Swiper(slider, {
    slidesPerView: 3,
    spaceBetween: 5,
    navigation: {
      nextEl: sliderNext,
      prevEl: sliderPrev
    },
    breakpoints: {
      768: {
        slidesPerView: 4,
        spaceBetween: 20
      },
      1024: {
        slidesPerView: 5
      },
      1200: {
        slidesPerView: 7,
        spaceBetween: 20
      }
    }
  });
}

sliderCollectionsThumbs();

function sliderReviews() {
  const $slider = $('.slider-reviews');
  const slider = $slider.find('.swiper-container')[0];
  const sliderNext = $slider.find('.slider-next')[0];
  const sliderPrev = $slider.find('.slider-prev')[0];

  const mySlider = new Swiper(slider, {
    slidesPerView: 'auto',
    spaceBetween: 10,
    navigation: {
      nextEl: sliderNext,
      prevEl: sliderPrev
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 55
      }
    }
  });
}

sliderReviews();

function sliderFeaturedCollection() {
  const $slider = $('.slider-featured-collection');
  const slider = $slider.find('.swiper-container')[0];
  const sliderNext = $slider.find('.slider-next')[0];
  const sliderPrev = $slider.find('.slider-prev')[0];

  const mySlider = new Swiper(slider, {
    slidesPerView: 'auto',
    navigation: {
      nextEl: sliderNext,
      prevEl: sliderPrev
    }
  });
}

sliderFeaturedCollection();


function sliderImages() {
  const $slider = $('.slider-images');
  const slider = $slider.find('.swiper-container')[0];
  const sliderNext = $slider.find('.slider-next')[0];
  const sliderPrev = $slider.find('.slider-prev')[0];

  const mySlider = new Swiper(slider, {
    slidesPerView: 'auto',
    spaceBetween: 7,
    navigation: {
      nextEl: sliderNext,
      prevEl: sliderPrev
    },
    breakpoints: {
      768: {
        spaceBetween: 13
      }
    }
  });
}

sliderImages();

function sliderGallery() {
  const $slider = $('.slider-gallery-thumbs');
  const $sliderThumbs = $slider.find('.js-slider-gallery');
  const $prev = $slider.find('.slider-prev');
  const $next = $slider.find('.slider-next');
  const slidesCount = $sliderThumbs.find('.slider__slide').length;
  const slidesArrowRightStop = slidesCount - 3;

  if (slidesCount <= 3) {
    $slider.addClass('has-less-slides');
  }

  $sliderThumbs.on('beforeChange', function(event, slick, currentSlide, nextSlide){
    if ($(window).width() < 768) {
      if (nextSlide >= slidesArrowRightStop) {
        $next.addClass('is-disabled');
      } else {
        $next.removeClass('is-disabled')
      }
    }
  });


  $sliderThumbs.on('init', function(event, slick){
    $('.product-gallery--navigation').addClass('is-initialized');
  });

  $sliderThumbs.slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    infinite: false,
    focusOnSelect: true,
    vertical: true,
    prevArrow: $prev,
    nextArrow: $next,
    responsive: [
    {
      breakpoint: 767,
      settings: {
        // centerMode: true,
        vertical: false,
        slidesToShow: 1,
        variableWidth: true
      }
    }
  ]
  });
}

sliderGallery();

function sliderGalleryHome() {
  const $slider = $('.slider-gallery-thumbs-home');
  const $sliderThumbs = $slider.find('.js-slider-gallery');
  const $prev = $slider.find('.slider-prev');
  const $next = $slider.find('.slider-next');
  const slidesCount = $sliderThumbs.find('.slider__slide').length;
  const slidesArrowRightStop = slidesCount - 3;

  $sliderThumbs.on('beforeChange', function(event, slick, currentSlide, nextSlide){
    if (nextSlide >= slidesArrowRightStop) {
      $next.addClass('is-disabled');
    } else {
      $next.removeClass('is-disabled')
    }
  });

  $sliderThumbs.on('init', function(event, slick){
    $('.product-gallery--navigation').addClass('is-initialized');
  });

  $sliderThumbs.slick({
    slidesToScroll: 1,
    dots: false,
    infinite: false,
    focusOnSelect: true,
    slidesToShow: 1,
    variableWidth: true,
    prevArrow: $prev,
    nextArrow: $next,
  });
}

sliderGalleryHome();


$('.js-menu-trigger').on('click', function() {
  $(this).toggleClass('is-active');
  $('.menu-default').toggleClass('is-active');
});

$('.js-menu-close').on('click', function() {
  $('.js-menu-trigger').removeClass('is-active');
  $('.menu-default').removeClass('is-active');
});

function promoBtns(minVal) {

  const $select = $('.form-field--qty-select');
  const $input = $('.form-field--qty-input');
  const $inputMain = $('#product-quantity-input');

  $select.addClass('hidden');
  $input.removeClass('hidden').addClass('visible');
  $inputMain.val( minVal );

  $('.btn-promo').on('click', function(e) {
    e.preventDefault();
    const $this = $(this);
    const value = $this.data('value');

    $this.addClass('is-active').parent().siblings().find('a').removeClass('is-active');
    $inputMain.val( parseInt($inputMain.val()) + parseInt(value) ).trigger("input");
  });

  $('#product-quantity-input').on('input', function() {
    $('.btn-promo').removeClass('is-active');
  });

}

/*
 Building promo Buttons on Bold load
*/
const ProdPriceSheet = document.getElementById('product_pricing_sheet');
let minBoldValue = 0;

// Looking for Bold pricelist load
let observer = new MutationObserver(mutationRecords => {
  
  const ProductBoldPrice = document.querySelector('[data-product-details] [data-price] .pre-money');
  const ProductRegularPrice = document.querySelector('[data-product-details] [data-price] .money:last-child');

  if (ProdPriceSheet.querySelector('div.money-template')) {

    let rows = ProdPriceSheet.querySelectorAll('.shappify_qb_grid tbody tr');
    let html = '';
    rows.forEach( (item,index) => {
      let quantity = item.querySelector('td:first-child').innerHTML
      let price = item.querySelector('td:last-child').innerHTML

      if(index) {
        if(index === 1) {minBoldValue = parseInt(quantity)}
        html +=  ` 
          <div class="buttons__item">
            <a href="#" class="btn-promo" data-value="${quantity}">
              <span class="btn__value">${quantity}</span>
              <span class="btn__text">${promo_html} ${price}</span>
            </a>
          </div>
          <!-- /.buttons__item -->
        `;
      }
      if(rows.length === index+1 && ProductRegularPrice) {
        ProductBoldPrice.style.display = 'none';
        ProductRegularPrice.style.display = 'block';
        ProductRegularPrice.innerHTML = price;
      }
    })
    document.querySelector('.product__qty-promos .buttons__items').innerHTML = html;
    promoBtns(minBoldValue);
    $('.product-pricing').show();
  }
});

//observing that
if(ProdPriceSheet) {

  $('.product-pricing').hide();

    observer.observe(ProdPriceSheet, {
      childList: true,
      subtree: true,
      characterDataOldValue: true
    });

    var waitForBold = setInterval(function() {
      if( typeof window.BOLD.csp !== 'undefined' ) {
        clearInterval( waitForBold );
        if( $('.money-template').length === 0 ) {
          setTimeout(
            function() {
              $('.product-pricing').show();
            },
            1000
          )
        }
      }
    }, 100);

}

/**
 * End promo Button implementation
 */


/* Handle max min amount JS START */

const handleMinMaxQuantity = (function () {

  function disableBunnon(val) {
    if(val) {
      $('.product-buttons button').prop('disabled', true);
    }
    if(!val) {
      $('.product-buttons button').prop('disabled', false);
    }
  }

  const $inputMain = $('#product-quantity-input');

  let pattern_1 = $('.pack_min_worning').text();
  let pattern_2 = $('.pack_closest_worning').text();

  $inputMain.on('input', function() {
    if( $('.shappify_qb_grid').length === 0 ) { return; }

    let currentAmount = 0;
    let minAmount = minBoldValue;
    let flag1 = true;
    let flag2 = true;

    if ( $(this).val() ) {
      currentAmount = parseInt($(this).val());
    }
    else {
      $(this).val(0);
      currentAmount = 0;
    }

    //Min Amount checker
    if(currentAmount < minAmount) {
      let txt = pattern_1.replace('{{X}}', currentAmount ).replace('{{Y}}', minAmount)
      $('.pack_min_worning').text(txt);
      $('.pack_min_worning').slideDown( "slow" );
      disableBunnon(true);
      flag1 = false;
    }
    else {
      $('.pack_min_worning').slideUp( "slow" );
      flag1 = true;
    }

    //if(currentAmount > minAmount && currentAmount !== 100 && currentAmount !== 5000) {
    if(currentAmount % minBoldValue !== 0 && currentAmount > minBoldValue) {

      var closest = currentAmount - (currentAmount % minBoldValue) + minBoldValue

      let txt = pattern_2.replace('{{X}}', currentAmount ).replace('{{Y}}', closest).replace('{{Y}}', minBoldValue);
      $('.pack_closest_worning').text(txt);
      $('.pack_closest_worning').slideDown( "slow" );
      disableBunnon(true);
      flag2 = false;
    }
    else {
      flag2 = true;
      $('.pack_closest_worning').slideUp( "slow" );
    }


    if( flag1 && flag2) {
        $('.pack_min_worning').slideUp( "slow" );
        $('.pack_closest_worning').slideUp( "slow" );
        disableBunnon(false);
    }

  })
})()
/* Handle max min amount JS END */

$('body').on('contextmenu', 'img', function(e) {
  return false;
});

$('.js-accordion-trigger').on('click', function() {
  const $this = $(this);

  $this.parent().toggleClass('is-active').siblings().removeClass('is-active');
  $this.next().slideToggle().parent().siblings().find('.accordion__body').slideUp();
});


const collectionsHtml = $('.js-collections-template').html();

$(window).on('load', function() {
  setTimeout(function() {
    if ($('.js-list-collections').hasClass('js-list-collections-hidden')) {
      $('.list-collections').addClass('is-hidden');
    }
  }, 500);
});

$(window).on('load', function() {
  setTimeout(function() {
    $('.list-collections ul').append(collectionsHtml);
  }, 1000);
});

$('.product-gallery--thumbnail-trigger').on('click', function() {
  $(this).addClass('thumbnail--selected').parent().siblings().find('.product-gallery--thumbnail-trigger').removeClass('thumbnail--selected');
});

$('.js-has-dropdown > a').on('click', function(event) {
  event.preventDefault();
  $(this).parent().find('.nav__dropdown-first').addClass('is-active');
});

$('.nav__dropdown-first__back').on('click', function(event) {
  event.preventDefault();
  $(this).parent().removeClass('is-active');
});

$('.js-has-dropdown-second > a').on('click', function(event) {
  event.preventDefault();
  const $this = $(this);
  $this.toggleClass('is-toggled');
  $this.next().slideToggle(400);
});

$('.form-field--checkbox input').on('click', function() {
  if($(this).prop('checked')) {
    $('.form-fields-columns--company').show();
  }
  else {
    $('.form-fields-columns--company').hide();
  }
});

if($('.form-field--checkbox input').prop('checked')) {
  $('.form-fields-columns--company').show();
}
else {
  $('.form-fields-columns--company').hide();
}

/* Disable quantity selector for BOLD items in cart */
window.addEventListener('load', function(){
  var cartItemsInputs = document.querySelectorAll('[data-line-index]');

  var waitForBold = setInterval(function() {
    if( typeof window.BOLD.csp !== 'undefined' ) {
      clearInterval( waitForBold );

      if(cartItemsInputs) {
        cartItemsInputs.forEach( function(el) {
          var val = parseInt(el.getAttribute('data-line-index'));
          if( BOLD.pre.getCartItemByLineIndex(val).discount ) {
            el.disabled = true;
          }
        })
      }

    }
  }, 100);

});

// Recomendations Quick shop minimum amount

const recomendationSection = document.querySelector('.product-recommendations');
const newPrice = document.createElement('span');

function observingRecomendations(){
  const quickShopButtons = document.querySelectorAll('[data-quickshop-slim]');
  quickShopButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const modalWrapper = document.querySelector('.modal-content');

      let modalContentObserver = new MutationObserver(() => {
        const priceSheet = modalWrapper.querySelector('#product_pricing_sheet');  
        const quantityInput = modalWrapper.querySelector('#product-quantity-input');
        if(priceSheet) {
          const priceWrapper = modalWrapper.querySelector('.price--main');
          const priceElement = document.querySelector('.modal-content [data-price] .money:last-child');
          const minPrice = modalWrapper.querySelector('.product-pricing').getAttribute('data-min-price');
          newPrice.classList.add('money');
          newPrice.innerHTML = Shopify.formatMoney(minPrice, theme.money_format);
          modalContentObserver.disconnect();
          priceWrapper.insertBefore(newPrice, priceElement);
          const qtyButtons = modalWrapper.querySelectorAll('[data-quantity-value]');
          quantityInput.value = qtyButtons[0].getAttribute('data-quantity-value');
          qtyButtons.forEach((btn) => {
            const quantity = btn.getAttribute('data-quantity-value');

            btn.addEventListener('click', () => {
              quantityInput.value = quantity;
            })
          })
        }
      })

      modalContentObserver.observe(modalWrapper, {
        childList: true,
        subtree: true
      }); 
    })
  })

  const recomendationProductsPrices = recomendationSection.querySelectorAll('.pre-money');
  recomendationProductsPrices.forEach((productPrice) => {
    const minPrice = productPrice.parentElement.parentElement.parentElement.getAttribute('data-min-price');
    productPrice.innerHTML = Shopify.formatMoney(minPrice, theme.money_format);
      recomendationsObserver.disconnect()
      recomendationsObserver.observe(recomendationSection, {
        childList: true,
        subtree: true
      });
  })
}

let recomendationsObserver = new MutationObserver(() => {  
  observingRecomendations();  
});

if(recomendationSection) {
  recomendationsObserver.observe(recomendationSection, {
    childList: true,
    subtree: true
  });
}

// Cloud Search Fix
const bodyElem = document.querySelector('body')

let searchObserver = new MutationObserver(() => {
  const cloudSearchClose = document.querySelector('.cloud-search-mobile__cancel');
  if(cloudSearchClose) {
    searchObserver.disconnect();
    cloudSearchClose.addEventListener('click', () => {
      document.querySelector('.live-search').classList.remove('live-search--takeover');
      document.querySelector('html').classList.remove('cloud-search-mobile-open');
      document.querySelector('.cloud-search-mobile-backdrop').style = 'display: none';
      document.querySelector('.cloud-search-mobile').style = 'display: none';
      bodyElem.classList.remove('scroll-lock');
    })  

    const liveSearchBtn = document.querySelector('.live-search-button--mobile');
    liveSearchBtn.addEventListener('click', () => {
      document.querySelector('html').classList.add('cloud-search-mobile-open');
      document.querySelector('.instant-search-menu--mobile').classList.add('instant-search-menu--mobile-input');
      document.querySelector('.cloud-search-mobile-backdrop').style = 'display: block';
      document.querySelector('.cloud-search-mobile').style = 'display: flex';
    })
  }
});

searchObserver.observe(bodyElem, {
  childList: true,
  subtree: true,
  characterDataOldValue: true
});